(function () {
  'use strict';

  if (window.__CART_GROUP_GUARD__) return;
  window.__CART_GROUP_GUARD__ = true;

  var GROUP_ID = '_group_id';
  var TYPE = '_type';
  var DEVICE_TYPES = ['device', 'ownership_device'];
  var SUB_TYPES = ['subscription', 'filter_subscription'];

  var PROTECTED_DEVICE_HANDLES = [
    'new-wisewell-sparkle-subscription',
    'new-wisewell-nano-subscription',
    'new-wisewell-model-1-subscription',
    'wisewell-sparkle-subscription',
    'wisewell-nano-subscription',
    'wisewell-model-1-subscription',
    'nano',
    'model-1',
    'sparkle'
  ];
  var COMPONENT_SKU_PREFIXES = ['SPK-120-', 'NNT-110-', 'MDO-110-'];

  var GIFT_HANDLES = ['gift-product'];
  var GIFT_SKUS = ['MSC-GFT-002'];
  var GIFT_PROP_KEYS = ['_salepify_gift', '_gift', 'gift', '_is_gift'];

  var isOnCartPage = window.location.pathname.indexOf('/cart') !== -1;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function url(path) {
    return root + path.replace(/^\/+/, '');
  }

  function getCart() {
    return fetch(url('cart.js'), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function changeLine(identifier, quantity, byIndex) {
    var payload = byIndex
      ? { line: identifier, quantity: quantity }
      : { id: identifier, quantity: quantity };
    return fetch(url('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Unable to update cart.');
        return data;
      });
    });
  }

  function updateLines(updates) {
    return fetch(url('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Unable to update cart.');
        return data;
      });
    });
  }

  function getGroupId(item) {
    return item && item.properties && item.properties[GROUP_ID] || null;
  }
  function getType(item) {
    return item && item.properties && item.properties[TYPE] || null;
  }
  function isDevice(item) {
    return DEVICE_TYPES.indexOf(getType(item)) !== -1;
  }
  function isSubscription(item) {
    return SUB_TYPES.indexOf(getType(item)) !== -1;
  }
  function hasSellingPlan(item) {
    return !!(item && (item.selling_plan_allocation || item.selling_plan_id));
  }
  function isProtectedHandle(item) {
    if (!item) return false;
    return PROTECTED_DEVICE_HANDLES.indexOf(item.handle || '') !== -1;
  }
  function isComponentSku(item) {
    var sku = (item && item.sku ? item.sku : '').toUpperCase();
    if (!sku) return false;
    for (var i = 0; i < COMPONENT_SKU_PREFIXES.length; i++) {
      if (sku.indexOf(COMPONENT_SKU_PREFIXES[i]) === 0) return true;
    }
    return false;
  }
  function isRemovableComponent(item) {
    if (!item) return false;
    if (isProtectedHandle(item)) return true;
    return isComponentSku(item) && item.final_price === 0;
  }
  function isGiftLine(item) {
    if (!item) return false;
    if (GIFT_HANDLES.indexOf(String(item.handle || '').toLowerCase()) !== -1) return true;
    if (GIFT_SKUS.indexOf(String(item.sku || '').toUpperCase()) !== -1) return true;
    var props = item.properties || {};
    for (var i = 0; i < GIFT_PROP_KEYS.length; i++) {
      if (props[GIFT_PROP_KEYS[i]]) return true;
    }
    var title = String(item.title || item.product_title || '').toLowerCase();
    if (item.final_price === 0 && title.indexOf('gift') !== -1) return true;
    return false;
  }

  var groups = {};
  var groupKeys = new Set();
  var variantIdToKey = {};
  var indexToKey = {};
  var stateLoaded = false;

  var rawItems = [];
  var cleanupComplete = false;
  var pendingCheckout = null;

  function refreshFromCart(cart) {
    rawItems = (cart && cart.items) || [];

    groups = {};
    groupKeys = new Set();
    variantIdToKey = {};
    indexToKey = {};

    (cart.items || []).forEach(function (item, index) {
      variantIdToKey[item.id] = item.key;
      if (item.variant_id) variantIdToKey[item.variant_id] = item.key;
      indexToKey[index + 1] = item.key;

      var gid = getGroupId(item);
      if (!gid) return;

      if (!groups[gid]) {
        groups[gid] = {
          deviceKey: null,
          subscriptionKey: null,
          deviceKeys: [],
          subscriptionKeys: [],
          deviceQty: 0,
          subscriptionQty: 0,
          hasSellingPlan: false,
          keys: new Set()
        };
      }

      var group = groups[gid];
      group.keys.add(item.key);
      groupKeys.add(item.key);
      if (hasSellingPlan(item)) group.hasSellingPlan = true;

      if (isDevice(item)) {
        group.deviceKey = item.key;
        group.deviceKeys.push(item.key);
        group.deviceQty = item.quantity;
      } else if (isSubscription(item)) {
        group.subscriptionKey = item.key;
        group.subscriptionKeys.push(item.key);
        group.subscriptionQty = item.quantity;
      }
    });
    stateLoaded = true;
  }

  function refreshFromServer() {
    return getCart().then(refreshFromCart).catch(function () {});
  }

  var loader = null;

  function ensureStyles() {
    if (document.getElementById('cart-group-loader-style')) return;
    var style = document.createElement('style');
    style.id = 'cart-group-loader-style';
    style.textContent =
      '.cart-group-loader{position:fixed;top:0;left:0;width:100%;height:100%;z-index:99999;' +
      'background:rgba(255,255,255,.55);display:flex;align-items:center;justify-content:center;' +
      'flex-direction:column;gap:12px;font-family:inherit;font-size:15px;color:#333}' +
      '.cart-group-loader__spinner{width:34px;height:34px;border:3px solid rgba(0,0,0,.15);' +
      'border-top-color:#000;border-radius:50%;animation:cartGroupSpin .7s linear infinite}' +
      '@keyframes cartGroupSpin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);
  }

  function showLoader() {
    if (loader) return;
    ensureStyles();
    loader = document.createElement('div');
    loader.className = 'cart-group-loader';
    loader.setAttribute('role', 'status');
    loader.setAttribute('aria-live', 'polite');
    loader.innerHTML = '<span class="cart-group-loader__spinner"></span><span>Updating your cart…</span>';
    document.body.appendChild(loader);
  }

  function hideLoader() {
    if (loader) {
      if (loader.parentNode) loader.parentNode.removeChild(loader);
      loader = null;
    }
  }

  function findOrphanGroupIds() {
    var out = [];
    for (var gid in groups) {
      var g = groups[gid];
      var deviceLive = !!(g.deviceKey && g.deviceQty > 0);
      var subLive = !!(g.subscriptionKey && g.subscriptionQty > 0);
      if (deviceLive !== subLive) {
        out.push(gid);
        continue;
      }
      if ((deviceLive || subLive) && !g.hasSellingPlan) out.push(gid);
    }
    return out;
  }

  function findUntaggedViolations() {
    var violations = [];
    if (!rawItems.length) return violations;

    var subCount = rawItems.filter(function (it) {
      var tagged = SUB_TYPES.indexOf(getType(it)) !== -1;
      var hasPlan = !!it.selling_plan_allocation;
      return (tagged || hasPlan) && (it.quantity || 0) > 0;
    }).length;

    rawItems.forEach(function (it) {
      if (!getGroupId(it) && !hasSellingPlan(it) && isRemovableComponent(it)) {
        violations.push(it.key);
        return;
      }
      if (isGiftLine(it) && subCount === 0) {
        violations.push(it.key);
      }
    });

    return violations;
  }

  function groupLineKeys(group) {
    var keys = [];
    function add(k) {
      if (k && keys.indexOf(k) === -1) keys.push(k);
    }
    group.subscriptionKeys.forEach(add);
    group.deviceKeys.forEach(add);
    add(group.subscriptionKey);
    add(group.deviceKey);
    return keys;
  }

  function deleteGroupLines(groupId) {
    var g = groups[groupId];
    if (!g) return Promise.resolve(null);

    var keys = groupLineKeys(g);
    if (!keys.length) return Promise.resolve(null);

    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });

    return updateLines(updates)
      .catch(function (err) {
        console.warn('[Cart Group] Group update refused, falling back:', err && err.message);
        var chain = Promise.resolve();
        keys.forEach(function (k) {
          chain = chain.then(function () {
            return changeLine(k, 0).catch(function () {});
          });
        });
        return chain;
      })
      .then(function () { return getCart(); });
  }

  function sweepLineByLine(untaggedKeys, orphanIds) {
    var chain = Promise.resolve();
    untaggedKeys.forEach(function (key) {
      chain = chain.then(function () {
        return changeLine(key, 0).catch(function () {});
      });
    });
    orphanIds.forEach(function (gid) {
      chain = chain.then(function () { return deleteGroupLines(gid); });
    });
    return chain;
  }

  function cleanupOrphans() {
    return getCart().then(function (cart) {
      refreshFromCart(cart);

      var orphans = findOrphanGroupIds();
      var untagged = findUntaggedViolations();

      if (!orphans.length && !untagged.length) {
        cleanupComplete = true;
        return null;
      }

      var beforeKeys = rawItems.map(function (it) { return it.key; }).join(',');

      var updates = {};

      untagged.forEach(function (key) {
        var victim = null;
        rawItems.some(function (it) {
          if (it.key !== key) return false;
          victim = it;
          return true;
        });
        console.warn(
          '[Cart Group] Removed "' + (victim ? (victim.handle || victim.title || key) : key) + '" — ' +
          (victim && isGiftLine(victim)
            ? 'founder gift without a subscription.'
            : 'device/component line with no selling plan and no _group_id.')
        );
        updates[key] = 0;
      });

      orphans.forEach(function (gid) {
        var g = groups[gid];
        if (g) {
          groupLineKeys(g).forEach(function (k) { updates[k] = 0; });
        }
      });

      return updateLines(updates)
        .catch(function (err) {
          console.warn('[Cart Group] Sweep refused, falling back:', err && err.message);
          return sweepLineByLine(untagged, orphans);
        })
        .then(function () {
        return getCart().then(function (c2) {
          refreshFromCart(c2);
          cleanupComplete = true;

          var afterKeys = rawItems.map(function (it) { return it.key; }).join(',');
          if (afterKeys !== beforeKeys) reloadCartPage(false);

          return c2;
        });
      });
    }).catch(function (err) {
      console.warn('[Cart Group] Cleanup failed:', err);
      cleanupComplete = true;
      return null;
    });
  }

  function applyGroupQuantity(groupId, qty) {
    qty = Math.max(0, parseInt(qty, 10) || 0);

    return getCart().then(function (cart) {
      refreshFromCart(cart);
      return runApply();
    }).catch(function (err) {
      console.warn('[Cart Group] Could not read cart:', err);
      return null;
    });

    function runApply() {
      var group = groups[groupId];
      if (!group) return Promise.resolve(null);

      var deviceLive = !!(group.deviceKey && group.deviceQty > 0);
      var subLive = !!(group.subscriptionKey && group.subscriptionQty > 0);

      if (deviceLive !== subLive) {
        return deleteGroupLines(groupId)
          .then(function (newCart) {
            refreshFromCart(newCart);
            return finalize(newCart);
          })
          .catch(function (err) {
            hideLoader();
            console.warn('[Cart Group] Orphan delete failed:', err);
            return null;
          });
      }

      if (!deviceLive && !subLive) return Promise.resolve(null);

      var updates = {};
      groupLineKeys(group).forEach(function (k) { updates[k] = qty; });

      function stepUpdateDevice() {
        if (group.deviceQty === qty) return Promise.resolve();
        return changeLine(group.deviceKey, qty);
      }
      function stepUpdateSub() {
        if (group.subscriptionQty === qty) return Promise.resolve();
        return changeLine(group.subscriptionKey, qty);
      }

      function sequence() {
        if (qty === 0) return stepUpdateSub().then(stepUpdateDevice);
        return stepUpdateDevice().then(stepUpdateSub);
      }

      return updateLines(updates)
        .catch(function (err) {
          console.warn('[Cart Group] Group update refused, falling back:', err && err.message);
          return sequence();
        })
        .then(function () { return getCart(); })
        .then(function (cart1) {
          refreshFromCart(cart1);

          var g = groups[groupId];
          if (!g) return cart1;

          var stillDeviceLive = !!(g.deviceKey && g.deviceQty > 0);
          var stillSubLive = !!(g.subscriptionKey && g.subscriptionQty > 0);

          if (qty === 0) {
            if (stillDeviceLive || stillSubLive) {
              return deleteGroupLines(groupId).then(function (c2) {
                refreshFromCart(c2);
                return c2;
              });
            }
            return cart1;
          }

          if (stillDeviceLive !== stillSubLive) {
            return deleteGroupLines(groupId).then(function (c2) {
              refreshFromCart(c2);
              return c2;
            });
          }

          if (g.deviceQty !== qty || g.subscriptionQty !== qty) {
            var chain = Promise.resolve();
            if (g.deviceQty !== qty) {
              chain = chain.then(function () { return changeLine(g.deviceKey, qty); });
            }
            if (g.subscriptionQty !== qty) {
              chain = chain.then(function () { return changeLine(g.subscriptionKey, qty); });
            }
            return chain.then(function () { return getCart(); }).then(function (c2) {
              refreshFromCart(c2);
              return c2;
            });
          }

          return cart1;
        })
        .then(function (finalCart) { return finalize(finalCart); })
        .catch(function (err) {
          console.warn('[Cart Group] Change failed:', err);
          if (!reloadCartPage(true)) {
            hideLoader();
            refreshFromServer();
          }
          return null;
        });
    }
  }

  var repaintDoneThisLoad = false;

  function reloadCartPage(force) {
    if (!isOnCartPage) return false;
    if (!force && repaintDoneThisLoad) return false;
    repaintDoneThisLoad = true;
    hideLoader();
    window.location.reload();
    return true;
  }

  function finalize(newCart) {
    if (reloadCartPage(true)) return newCart;
    hideLoader();
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: newCart } }));
      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-group-sync', cartData: newCart });
      }
    } catch (e) {}
    return newCart;
  }

  function applySingleQuantity(identifier, qty, byIndex) {
    qty = Math.max(0, parseInt(qty, 10) || 0);
    return changeLine(identifier, qty, byIndex)
      .then(function (newCart) {
        refreshFromCart(newCart);
        return finalize(newCart);
      })
      .catch(function (err) {
        console.warn('[Cart Group] Single change failed:', err);
        if (!reloadCartPage(true)) hideLoader();
        return null;
      });
  }

  function lineIndexForRow(row, element) {
    var el = element || row;
    var idx = el && el.getAttribute ? el.getAttribute('data-index') : null;
    if (!idx && row && row.querySelector) {
      var indexEl = row.querySelector('cart-remove-button[data-index], [data-index]');
      if (indexEl) idx = indexEl.getAttribute('data-index');
    }
    var n = parseInt(idx, 10);
    return isNaN(n) ? null : n;
  }

  function keyForRow(row, element) {
    var el = element || row;

    if (el && el.closest) {
      var keyed = el.closest('[data-line-key]');
      if (keyed) {
        var k = keyed.getAttribute('data-line-key');
        if (k) return k;
      }
    }

    var key = el && el.getAttribute
      ? (el.getAttribute('data-key') || el.getAttribute('data-line-key'))
      : null;
    if (key) return key;

    var vid = el && el.getAttribute
      ? (el.getAttribute('data-variant-id') || el.getAttribute('data-quantity-variant-id'))
      : null;
    if (vid && variantIdToKey[vid]) return variantIdToKey[vid];

    var line = lineIndexForRow(row, element);
    if (line && indexToKey[line]) return indexToKey[line];
    return null;
  }

  function rowSelector() {
    return '.cart-item, .cart__item, [data-cart-item]';
  }

  function getGroupIdForKey(key) {
    if (!key) return null;
    for (var gid in groups) {
      if (groups[gid].keys.has(key)) return gid;
    }
    return null;
  }

  var syncing = false;

  var QTY_BTN_SELECTOR =
    '.quantity__button[name="minus"], .quantity__button[name="plus"], ' +
    '.quantity__button[data-quantity-minus], .quantity__button[data-quantity-plus]';

  var PLUS_BTN_SELECTOR =
    '.quantity__button[name="plus"], .quantity__button[data-quantity-plus]';

  var REMOVE_SELECTOR =
    'cart-remove-button, a[href*="/cart/change"], button[name="remove"], ' +
    '[data-cart-remove], [data-cart-item-remove]';

  function resolveAndApply(key, line, qty) {
    function apply() {
      var resolvedKey = key || (line && indexToKey[line]) || null;
      var gid = resolvedKey ? getGroupIdForKey(resolvedKey) : null;
      if (gid) return applyGroupQuantity(gid, qty);
      if (resolvedKey) return applySingleQuantity(resolvedKey, qty, false);
      if (line) return applySingleQuantity(line, qty, true);
      return Promise.resolve(null);
    }
    if (stateLoaded) return apply();
    return getCart().then(function (cart) {
      refreshFromCart(cart);
      return apply();
    }).catch(function () {
      stateLoaded = true;
      return apply();
    });
  }

  window.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var row = target.closest(rowSelector());
    if (!row) return;

    var isRemove = !!target.closest(REMOVE_SELECTOR);
    var isQtyBtn = !!target.closest(QTY_BTN_SELECTOR);
    if (!isRemove && !isQtyBtn) return;

    var line = lineIndexForRow(row, target);
    var key = keyForRow(row, target);
    if (!key && !line) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (syncing) return;

    showLoader();

    var qty;
    if (isRemove) {
      qty = 0;
    } else {
      var input = row.querySelector('.quantity__input');
      var current = parseInt(input && input.value, 10);
      current = isNaN(current) ? 0 : current;
      var isPlus = !!target.closest(PLUS_BTN_SELECTOR);
      qty = isPlus ? current + 1 : Math.max(0, current - 1);
      if (input) input.value = qty;
    }

    syncing = true;
    resolveAndApply(key, line, qty).finally(function () {
      syncing = false;
      hideLoader();
      cleanupOrphans();
    });
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.classList || !target.classList.contains('quantity__input')) return;
    var row = target.closest(rowSelector());
    if (!row) return;

    var qty = parseInt(target.value, 10);
    if (isNaN(qty)) return;

    var line = lineIndexForRow(row, target);
    var key = keyForRow(row, target);
    if (!key && !line) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (syncing) return;

    showLoader();

    syncing = true;
    resolveAndApply(key, line, qty).finally(function () {
      syncing = false;
      hideLoader();
      cleanupOrphans();
    });
  }, true);

  var CHECKOUT_SELECTOR =
    'button[name="checkout"], input[name="checkout"], ' +
    'a[href$="/checkout"], a[href*="/checkout?"], ' +
    '[data-checkout], .cart__checkout-button';

  window.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var checkoutEl = target.closest(CHECKOUT_SELECTOR);
    if (!checkoutEl) return;

    if (cleanupComplete) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    showLoader();
    pendingCheckout = checkoutEl;

    cleanupOrphans().finally(function () {
      hideLoader();
      var el = pendingCheckout;
      pendingCheckout = null;
      if (!el) return;

      if (el.tagName === 'A' && el.href) {
        window.location.href = el.href;
      } else if (el.form) {
        if (typeof el.form.requestSubmit === 'function') {
          el.form.requestSubmit(el);
        } else {
          el.form.submit();
        }
      } else {
        el.click();
      }
    });
  }, true);

  document.addEventListener('cart:updated', function (event) {
    var cart = event && event.detail && event.detail.cart;
    cleanupComplete = false;
    if (cart) {
      refreshFromCart(cart);
      cleanupOrphans();
    } else {
      setTimeout(function () {
        refreshFromServer().then(cleanupOrphans);
      }, 50);
    }
  });

  document.addEventListener('cart:refresh', function () {
    cleanupComplete = false;
    setTimeout(function () {
      refreshFromServer().then(cleanupOrphans);
    }, 50);
  });

  refreshFromServer().then(function () {
    return cleanupOrphans();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refreshFromServer().then(function () {
        return cleanupOrphans();
      });
    });
  }

  window.cartGroupGuard = {
    sync: function () {
      return refreshFromServer().then(cleanupOrphans).catch(function (err) {
        console.warn('[Cart Group] Manual sync failed:', err);
        cleanupComplete = true;
        return null;
      });
    },
    isClean: function () {
      return cleanupComplete;
    },
    whenClean: function () {
      if (cleanupComplete) return Promise.resolve(true);
      return new Promise(function (resolve) {
        var tries = 0;
        (function poll() {
          if (cleanupComplete || ++tries > 50) return resolve(cleanupComplete);
          setTimeout(poll, 60);
        })();
      });
    }
  };
})();